export default __webpack_public_path__ + "static/media/Animation-tick.2b696b67.gif";